import React from 'react';

import '../navbar/navbar.css';
import Navbar from '../navbar/navbar';

import '../bookings/bookings.css';
import Bookingspage from '../bookings/bookings.js';

import '../navbar/footer.css';
import Footer from '../navbar/footer';


import Bkbannerp from '../bookings/bkbanner.js'; 


function Bookings() {
    return (
        <>

            <Bkbannerp />

            <Bookingspage />

            <Footer />

        </>
    )
}

export default Bookings;